import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBag3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBag3"><Path d="M22 21H2V12.3467L11 13.8467V15H13V13.8018L22 11.8018V21Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M17.0039 6H22V9.75293L13 11.752V11H11V11.8193L2 10.3193V6H7.00391V2H17.0039V6ZM9.00391 6H15.0039V4H9.00391V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBag3;
